import script from "./ErrorE404.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorE404.vue?vue&type=script&setup=true&lang=js"

import "./ErrorE404.vue?vue&type=style&index=0&id=77487528&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77487528"]])

export default __exports__